export default {
    components: {

    },
    filters: {
    },
    data() {
        return {

        }
    },
    computed: {

    },
    watch: {

    },
    created() {

    },
    methods: {
        /**
         * @description 驗證姓名是否有填
         */
        async validateFullName(fullName) {
            return new Promise((resolve, reject) => {
                if (fullName.length > 0) {
                    resolve()
                }
                if (fullName.length === 0) {
                    this.$alert(`請先填入會員名稱`, '驗證有誤', {
                        confirmButtonText: '確認',
                        center: true,
                    })
                    reject(new Error("please key in fullName"))
                }
            })
        },
    }
}